import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {VehiclesAvailability} from '../../common/actionTypes';

const INITIAL_STATE = {
  'loadingChassis': false,
  'chassisList': [],
  'loadingGeneralData': false,
  'generalData': {},
  'loading': false,
  'inputData': {},
  'outputData': {},
  'orders': [],
};

export const vehicleHistory = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_VEHICLE_CHASSIS]: (state, action) => ({
      ...state,
      'loadingChassis': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_CHASSIS]: (state, action) => ({
      ...state,
      'loadingChassis': false,
      'chassisList': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLE_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loadingChassis': false,
      'chassisList': [],
    }),
    [ActionTypes.FETCHING_GENERAL_DATA_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loadingGeneralData': true,
      'generalData': {},
    }),
    [ActionTypes.FETCHED_GENERAL_DATA_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loadingGeneralData': false,
      'generalData': action.response.data,
    }),
    [ActionTypes.FETCHED_GENERAL_DATA_BY_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loadingGeneralData': false,
      'generalData': {},
    }),
    [ActionTypes.FETCHING_INPUT_DATA_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': true,
      'inputData': {},
    }),
    [ActionTypes.FETCHED_INPUT_DATA_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': false,
      'inputData': action.response.data,
    }),
    [ActionTypes.FETCHED_INPUT_DATA_BY_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'inputData': {},
    }),
    [ActionTypes.FETCHING_OUTPUT_DATA_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': true,
      'outputData': {},
    }),
    [ActionTypes.FETCHED_OUTPUT_DATA_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': false,
      'outputData': action.response.data,
    }),
    [ActionTypes.FETCHED_OUTPUT_DATA_BY_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'outputData': {},
    }),
    [VehiclesAvailability.FETCHING_ORDERS_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [VehiclesAvailability.FETCHED_ORDERS_BY_CHASSIS]: (state, action) => ({
      ...state,
      'loading': false,
      'orders': action.response.data,
    }),
    [VehiclesAvailability.FETCHED_ORDERS_BY_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'orders': [],
    }),
  })(state, action);
};
